module.exports = __webpack_public_path__ + "img/register-logo.34c0f4d4.png";